<template>
  <mdb-container fluid>
    <DataTableAG
      deleteparam="frontpageids"
      :columns="columns"
      width="1150px"
      height="1600px"
      archivecontentpath2="2.0/newbe/unionfrontpage/delete"
      archiveparam="id"
      :getcontentpath="getfrontpagespath"
      :buttonList="['Muokkaa', 'Poista etusivu', 'Vaihda aktiivisuus']"
      jsonobject="unionmembers"
      :image="true"
      v-on:pressed-button1="editFrontPage"
      v-on:pressed-button2="deleteFrontPage"
      v-on:pressed-button3="switchActive"
      :rowHeight="130"
    />
  </mdb-container>
</template>

<script>
import DataTableAG from "@/components/DataTableAG.vue";
import { mdbContainer } from "mdbvue";

export default {
  name: "FrontPages",
  components: {
    DataTableAG,
    mdbContainer,
  },
  methods: {
    editFrontPage(rowData) {
      this.$router.push("/addfrontpage/" + rowData.id);
    },
    deleteFrontPage(rowData) {
      this.$http
        .delete(
          this.deletefrontpagespath + rowData.id
        )
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("swiching_front_page_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
          setTimeout(() => {
            this.$router.go();
          }, 1000);
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("swithing_front_page_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutmedium,
          });
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
    switchActive(rowData) {
      this.postData = {
        id: rowData.id,
        frontpageactive: 1 - rowData.frontpageactive,
      };
      this.$http
        .post(
          this.setactivefrontpagespath,
          JSON.stringify(this.postData)
        )
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("swiching_front_page_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
          setTimeout(() => {
            this.$router.go();
          }, 1000);
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("swithing_front_page_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutmedium,
          });
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  },
  data: () => ({
    getfrontpagespath: "/1.0/front/unionmembers",
    setactivefrontpagespath: "/1.0/front/unionmember/frontpage/activate",
    deletefrontpagespath: "/1.0/front/unionmember/frontpage/",
    columns: [
      {
        field: "id",
        headerName: "Liitto",
        width: 100,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "title1",
        headerName: "Otsikko1",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "logo",
        headerName: "Logo",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
        cellRenderer: "SimpleImageComponent",
      },
      {
        field: "img1",
        headerName: "Kuva 1",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
        cellRenderer: "SimpleImageComponent",
      },
      {
        field: "img2",
        headerName: "Kuva 2",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
        cellRenderer: "SimpleImageComponent",
      },
      {
        field: "frontpageactive",
        headerName: "Aktiivinen",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
    ],
  }),
  mounted() {},
};
</script>